import { resolveFilestackApiKey } from "../../utils/filestackApiKey";
import { sanitizeUploadFilename } from "utils/sanitizeUploadFilename";

var select = function (upload_type, payload) {
  var upload_path = "/" + payload.environment + payload.path;
  const client = filestack.init(resolveFilestackApiKey());

  const options = {
    accept: ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"],
    maxSize: 1024 * 1024 * 10,
    maxFiles:
      payload.maxFiles && Number(payload.maxFiles) > 0
        ? Number(payload.maxFiles)
        : 1,
    storeTo: {
      location: "s3",
      path: upload_path,
      access: "public",
    },
    uploadConfig: {
      retry: 5,
      timeout: 180000,
    },
    supportEmail: "support@convertflow.com",
    fromSources: ["local_file_system", "url"],
    transformationsUI: false,
    viewType: "grid",
    onOpen: function () {
      $(document).off("focusin.modal");
      window.filestackOpen = true;
      if (payload.modal) $(payload.modal).modal("hide");
    },
    onClose: function () {
      window.filestackOpen = false;
      if (payload.modal) $(payload.modal).modal("show");
      payload.onClose && payload.onClose();
    },
    onFileSelected: function (file) {
      if (!file) return file;

      var original = file.filename || file.name || "";
      if (!file.cf_original_filename) {
        file.cf_original_filename = original;
      }
      var safe = sanitizeUploadFilename(original);
      file.filename = safe;
      if (file.name) file.name = safe;
      return file;
    },
    onFileUploadFinished: function (file) {
      if (file && file.source == "local_file_system") {
        payload.onUploadFinished && payload.onUploadFinished(file);
        uploads.transform(upload_type, payload, file);

        if (payload.modal) $(payload.modal).modal("show");
      }
    },
    onUploadStarted: function (files) {
      if (!payload.onUploadStarted) return;
      (Array.isArray(files) ? files : [files]).forEach(function (file) {
        payload.onUploadStarted(file);
      });
    },
    onUploadDone: function (upload) {
      const files = (upload && upload.filesUploaded) || [];
      files.forEach((file) => {
        if (file && file.source !== "local_file_system") {
          payload.onUploadFinished && payload.onUploadFinished(file);
          uploads.transform(upload_type, payload, file);

          if (payload.modal) $(payload.modal).modal("show");
        }
      });
    },
  };

  // cta builder options
  if (payload.library == true) {
    $.extend(options, {
      customSourceName: "Image Library",
      customSourceContainer: "uploads.convertflow.co",
      customSourcePath:
        payload.environment +
        "/websites/" +
        (payload.website_id || cta.website_id) +
        "/",
    });

    options["fromSources"] = [
      "local_file_system",
      "customsource",
      "unsplash",
      "url",
    ];
  }

  client.picker(options).open();
};

export default select;
